import { Button } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { useCallback, useEffect, useState } from "react";
import { TimeRangeFinite } from "types/types";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { useDeleteRetrotag } from "../RetrotagPopper/retrotagMutationHooks";
import { useHandleCloseModal } from "./timelineTooltipUtils";

export function RemoveRetrotagForm({
  closeForm,
  machemetryId,
  retrotagOperationId,
  segmentRange,
}: {
  closeForm: () => void;
  machemetryId: string;
  retrotagOperationId: string;
  segmentRange: TimeRangeFinite;
}) {
  const [hasSubmittedForm, setHasSubmittedForm] = useState(false);
  const [didMutationFail, setDidMutationFail] = useState(false);

  const { translate } = useFlightTranslation();

  const [deleteRetrotag] = useDeleteRetrotag({
    operationId: retrotagOperationId,
    machemetryId,
    segmentRange,
  });
  const handleCloseModal = useHandleCloseModal();

  const handleClose = useCallback(() => {
    setHasSubmittedForm(false);
    setDidMutationFail(false);
    closeForm();
    handleCloseModal();
  }, [closeForm, handleCloseModal]);

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await deleteRetrotag();
    } catch {
      setDidMutationFail(true);
    }
    setHasSubmittedForm(true);
  };

  useEffect(() => {
    if (hasSubmittedForm && didMutationFail) {
      setTimeout(handleClose, 800);
    } else if (hasSubmittedForm) {
      handleClose();
    }
  }, [hasSubmittedForm, handleClose, didMutationFail]);

  return (
    <form className="removeRetrotagForm" onSubmit={handleFormSubmit}>
      <div className="removeRetrotagFormPaper">
        {didMutationFail ? (
          <ErrorIcon fontSize="large" color="secondary" />
        ) : (
          <>
            <p>{translate("Are_you_sure_you_want_to_delete_this_retrotag")}</p>
            <div className="bottomButtons">
              <Button className="cancelButton" onClick={closeForm}>
                {translate("Cancel")}
              </Button>
              <Button
                className="deleteButton confirmDeleteButton"
                type="submit"
              >
                {translate("Delete")}
              </Button>
            </div>
          </>
        )}
      </div>
      <div className="backdrop" />
    </form>
  );
}
